import { IType } from '../../../../api/Rover/types';

export default function SummaryStatusWidget({ summary }: { summary: IType[] }) {
  const findCount = (statusType: string) => {
    const status = summary?.find((item) => item?.status === statusType);

    return status?._count?.status || 0;
  };
  return (
    <>
      <div className='bg-white rounded-md flex flex-row px-4 py-6 relative'>
        <div className='flex-grow flex flex-col justify-between font-bold'>
          <div className='flex gap-6 items-center'>
            <h4>Summary Status:</h4>
            <div className='flex items-center gap-2'>
              <div className='w-3 h-3 bg-neutralColor-normal rounded-full'></div>
              <h5 className='font-medium'>
                Submitted: {findCount('SUBMITTED')}
              </h5>
            </div>
            <div className='flex items-center gap-2'>
              <div className='w-3 h-3 bg-secondaryColor-normal rounded-full'></div>
              <h5 className='font-medium'>
                Under Review: {findCount('UNDER_REVIEW')}
              </h5>
            </div>
            <div className='flex items-center gap-2'>
              <div className='w-3 h-3 bg-blue-500 rounded-full'></div>
              <h5 className='font-medium'>
                Document Requested: {findCount('DOCUMENT_REQUESTED')}
              </h5>
            </div>
            <div className='flex items-center gap-2'>
              <div className='w-3 h-3 bg-primaryColor-normal rounded-full'></div>
              <h5 className='font-medium'>Approved: {findCount('APPROVED')}</h5>
            </div>
            <div className='flex items-center gap-2'>
              <div className='w-3 h-3 bg-tertiaryColor-normal rounded-full'></div>
              <h5 className='font-medium'>Denied: {findCount('DENIED')}</h5>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
